export default "__VITE_PUBLIC_ASSET__8a6aebb0__"